import localeUtils from 'utils/LanguageLocale';
import AddressEN from 'constants/locales/Address_en_US';
import AddressFR from 'constants/locales/Address_fr_CA';

const getAddressConst = (isReleaseThreeVerifyAddressModal = false) => {
    const getText = localeUtils.getLocalisedDataFromResource(AddressEN, AddressFR);

    return {
        ADDRESS_VERIFICATION_TYPE: {
            RECOMMENDED: 'RECOMMENDED',
            UNVERIFIED: 'UNVERIFIED'
        },
        ADDRESS_VERIFICATION_LEVEL: {
            POOR: 'poor',
            QUESTIONABLE: 'questionable',
            GOOD: 'good'
        },
        // GIM-5450: AVS Loqate v2 5-state decision contract (epic GIM-5392, PRD v2.8).
        // Additive — legacy ADDRESS_VERIFICATION_LEVEL stays for the flag-off path.
        ADDRESS_DECISION: {
            ACCEPTED: 'ACCEPTED',
            SUGGESTED: 'SUGGESTED',
            SOFT_BLOCK: 'SOFT_BLOCK',
            HARD_BLOCK: 'HARD_BLOCK',
            BYPASSED: 'BYPASSED'
        },
        // GIM-5452 (E2-3): maps server-side field names (highlightedFields[]) to UFE form input keys.
        // Covers the full AVS field vocabulary (firstName · lastName · phone · addressLine1 ·
        // addressLine2 · city · state · province · postalCode) plus the legacy address1/address2/country
        // aliases the forms already use. CA returns province for the state input.
        HIGHLIGHT_FIELD_MAP: {
            firstName: 'firstName',
            lastName: 'lastName',
            phone: 'phone',
            addressLine1: 'address1',
            addressLine2: 'address2',
            address1: 'address1',
            address2: 'address2',
            city: 'city',
            state: 'state',
            province: 'state',
            postalCode: 'postalCode',
            country: 'country'
        },
        ADDRESS_VERIFICATION_MODAL: {
            UNVERIFIED: {
                TITLE: getText(isReleaseThreeVerifyAddressModal ? 'unverifiedTitleR3' : 'unverifiedTitle'),
                LEGEND: getText(isReleaseThreeVerifyAddressModal ? 'unverifiedLegendR3' : 'unverifiedLegend'),
                BUTTON_TEXT: getText(isReleaseThreeVerifyAddressModal ? 'unverifiedButtonTextR3' : 'unverifiedButtonText'),
                DATA_AT: Sephora.debug.dataAt('double_check_modal')
            },
            RECOMMENDED: {
                TITLE: getText('recommendedTitle'),
                BUTTON_TEXT: getText('recommendedButtonText'),
                DATA_AT: Sephora.debug.dataAt('recommend_address_modal')
            }
        }
    };
};

export default getAddressConst;
